import { config } from 'zod';

/**
 * Disable Zod's JIT object-parser.
 *
 * Zod compiles a validator specialised to each object schema by handing a generated string to
 * `new Function` (zod/v4/core/doc.js). That is an eval, and the Content-Security-Policy served by
 * docker/headers.conf.template grants no 'unsafe-eval', so every compile raises a CSP violation -
 * one per object node in a schema tree, not one per page.
 *
 * Import order matters. Zod reads this flag when each object schema is CONSTRUCTED, not when it
 * parses, so a schema built before this module runs keeps its compiler. Domain schemas in
 * @faro/study-designer-model are built at module-evaluation time, which is why src/index.tsx
 * imports this file first.
 */
config({ jitless: true });
